module.exports = __webpack_public_path__ + "img/business_verification.7499bf9f.png";